export default __webpack_public_path__ + "static/media/hht2_storybook_17.7525a455.png";